angular.module('ikeweb.repository', [
    'ikeweb.shared.repository.parse',
    'ikeweb.shared.progress',
    'ikeweb.shared.caching',
    'ikeweb.user',
    'ikeweb.shared.promise'
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/repository/repository.module.js
// module id = 445
// module chunks = 0